import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=1b00a5be&scoped=true"
import script from "./Table.vue?vue&type=script&lang=ts"
export * from "./Table.vue?vue&type=script&lang=ts"
import style0 from "./Table.vue?vue&type=style&index=0&id=1b00a5be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b00a5be",
  null
  
)

export default component.exports